import React, { useEffect, useState } from 'react';
import { Card, Typography, Row, Col, Space, Spin, Empty, Button } from 'antd';
import { EyeOutlined, UserOutlined, GiftOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { listLandingPagesForCurrentCustomer, type LandingPageDTO } from '../../services/landingPages';
import { useNavigate } from 'react-router-dom';
import './customerHome.css';

const { Title, Text } = Typography;

const CustomerLandingPages: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [landingPages, setLandingPages] = useState<LandingPageDTO[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const res = await listLandingPagesForCurrentCustomer({ page: 0, size: 200 });
        const pages: LandingPageDTO[] =
          (res as any)?.content ?? (Array.isArray(res) ? (res as LandingPageDTO[]) : []);
        if (!cancelled) setLandingPages(pages);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="customer-home-v2">
      <div className="container-v2">
        <div className="header-v2" style={{ marginBottom: 16 }}>
          <div className="header-content-v2">
            <div className="user-info">
              <div className="user-details">
                <Text className="welcome-label">Panoramica landing</Text>
                <Title level={2} className="user-name">Le tue landing</Title>
              </div>
            </div>
            <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate('/home')} className="logout-button-v2">
              Torna alla dashboard
            </Button>
          </div>
        </div>

        {loading ? (
          <div className="loading-state">
            <Spin size="large" />
          </div>
        ) : landingPages.length === 0 ? (
          <Card className="empty-card" bordered={false}>
            <Empty description="Non ci sono landing collegate" />
          </Card>
        ) : (
          <Row gutter={[16, 16]}>
            {landingPages.map((lp) => {
              const views = lp.totalViews ?? 0;
              const leads = lp.totalSubmissions ?? 0;
              const redeemed = lp.totalCouponRedeemed ?? 0;
              return (
                <Col xs={24} md={12} lg={8} key={lp.id}>
                  <Card className="visibility-card-v2" bordered={false} hoverable>
                    <div className="visibility-header" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{ flex: 1 }}>
                        <Title level={4} className="visibility-title" style={{ marginBottom: 0 }}>
                          {lp.name}
                        </Title>
                        <Text className="visibility-subtitle">
                          <a href={`https://landing.miglioriamo.com/${lp.slug}`} target="_blank" rel="noopener noreferrer">
                            {`https://landing.miglioriamo.com/${lp.slug}`}
                          </a>
                        </Text>
                      </div>
                    </div>

                    <div className="metrics-grid" style={{ marginTop: 16 }}>
                      <div className="metric-item">
                        <div className="metric-icon" style={{ background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)' }}>
                          <EyeOutlined />
                        </div>
                        <div className="metric-info">
                          <Text className="metric-label">Visite</Text>
                          <div className="metric-value">{views}</div>
                        </div>
                      </div>

                      <div className="metric-item">
                        <div className="metric-icon" style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
                          <UserOutlined />
                        </div>
                        <div className="metric-info">
                          <Text className="metric-label">Lead</Text>
                          <div className="metric-value">{leads}</div>
                        </div>
                      </div>

                      <div className="metric-item">
                        <div className="metric-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
                          <GiftOutlined />
                        </div>
                        <div className="metric-info">
                          <Text className="metric-label">Coupon riscattati</Text>
                          <div className="metric-value">{redeemed}</div>
                        </div>
                      </div>
                    </div>

                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </div>
    </div>
  );
};

export default CustomerLandingPages;
